module.exports = {
  AUTO: 'auto',
  RASTER: 'raster',
  VECTOR: 'vector'
};



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/geo/render-modes.js
// module id = 1053
// module chunks = 6